<div [class]="!vertical ? 'text-divider' : 'vertical-text-divider'">
    <ng-content></ng-content>
</div>
